function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
import React from "react";
import { hasPath } from "./object-path";
export var isString = function(value) {
    return typeof value === "string";
};
export var isNumber = function(value) {
    return typeof value === "number" && !Number.isNaN(value);
};
export var isObject = function(item) {
    return (typeof item === "undefined" ? "undefined" : _type_of(item)) === "object" && item !== null && Object.prototype.toString.call(item) === "[object Object]";
};
export var isArrayOfStrings = function(value) {
    return Array.isArray(value) && value.every(function(item) {
        return typeof item === "string";
    });
};
export var isUUID = function(value) {
    if (!isString(value)) return false;
    var regexExp = /^[0-9a-f]{8}\b-[0-9a-f]{4}\b-[0-9a-f]{4}\b-[0-9a-f]{4}\b-[0-9a-f]{12}$/gi;
    return regexExp.test(value);
};
export var isJSXElement = function(child) {
    return React.isValidElement(child);
};
export var hasAllRequiredFields = function(obj, requiredFields) {
    return requiredFields.every(function(field) {
        return Object.hasOwn(obj, field);
    });
};
export var isInputEvent = function(e) {
    var currentTarget = e.currentTarget;
    return isNotEmpty(currentTarget) && "value" in currentTarget;
};
export var isEventTargetElement = function(e) {
    var target = e.target;
    return isNotEmpty(target) && "tagName" in target;
};
export var isNotEmpty = function(value) {
    return value !== null && value !== undefined;
};
export var isGridElement = function(element) {
    return isNotEmpty(element) && "selectItem" in element;
};
// Validate API exceptions
export var isErrorObject = function(data) {
    return (typeof data === "undefined" ? "undefined" : _type_of(data)) === "object" && data !== null && ("message" in data && data.message !== null && data.message !== "" && (_type_of(data.message) !== "object" || Object.keys(data.message).length > 0) || "response" in data && data.response !== null && data.response !== "" && (_type_of(data.response) !== "object" || Object.keys(data.response).length > 0));
};
export var isHttpError = function(data) {
    return (typeof data === "undefined" ? "undefined" : _type_of(data)) === "object" && data !== null && "code" in data && (typeof data.code === "string" && data.code.length > 0 || typeof data.code === "number" && data.code !== 0);
};
export var isParsingError = function(data) {
    return (typeof data === "undefined" ? "undefined" : _type_of(data)) === "object" && data !== null && "errors" in data && Array.isArray(data.errors) && data.errors.length > 0;
};
// Marketplace validators
export var isMarketplaceProject = function(data) {
    return (typeof data === "undefined" ? "undefined" : _type_of(data)) === "object" && data !== null && hasPath(data, "Instances.0.ActiveDeployment.Package.ProductVersions.0.Product".split("."));
};
export var isMarketplaceDeployment = function(data) {
    return (typeof data === "undefined" ? "undefined" : _type_of(data)) === "object" && data !== null && hasPath(data, "Package.ProductVersions.0".split("."));
};

//# sourceMappingURL=validators.js.map